import { Create, CreateProps, SimpleFormProps } from 'react-admin';

import { DefaultForm } from '../DefaultForm';

interface ToolbarProps {
  resourceSingular: string;
  customDiscardValidation?(): boolean;
  onClose?(): void;
}

export type CreateViewProps = Omit<CreateProps, 'children'> & SimpleFormProps & ToolbarProps;

export default function CreateView({
  children,
  onClose,
  resourceSingular,
  customDiscardValidation,
  validate,
  onSubmit,
  defaultValues,
  ...props
}: CreateViewProps) {
  return (
    <Create redirect="list" {...props}>
      <DefaultForm
        onClose={onClose}
        customDiscardValidation={customDiscardValidation}
        defaultValues={defaultValues}
        resourceSingular={resourceSingular}
        validate={validate}
        hideDelete={true}
        onSubmit={onSubmit}>
        {children}
      </DefaultForm>
    </Create>
  );
}
